import { CSSObject, Theme } from '@core-ui/react-stitch';

const buttonBackgroundColorForBananaRepublicRedesign = (
  t: Theme,
  isApplied: boolean
) =>
  // isApplied ? t.color.b2 : t.color.inverse?.b1
  isApplied ? '#000000' : '#F6F4EB';

const getButtonBackgroundColorForBananaRepublic = (
  t: Theme,
  isApplied: boolean
) => buttonBackgroundColorForBananaRepublicRedesign(t, isApplied);

const getAppliedButtonTextColorForBR = (t: Theme) => t.color.wh;

const getButtonTextColorForBananaRepublic = (t: Theme, isApplied: boolean) => {
  if (isApplied) {
    return getAppliedButtonTextColorForBR(t);
  }
  // return t.color.b2;
  return '#000000';
};

export const getSizeButtonStyleForBananaRepublic = (
  t: Theme,
  applied: boolean
): CSSObject => ({
  lineHeight: '0.9',
  backgroundColor: getButtonBackgroundColorForBananaRepublic(t, applied),
  color: getButtonTextColorForBananaRepublic(t, applied),
  padding: '0.375rem 0.5rem',
  fontSize: '0.875rem',
  fontWeight: 100,
});

export const getVariantButtonStyleForBananaRepublic = (
  t: Theme,
  applied: boolean
): CSSObject => ({
  backgroundColor: getButtonBackgroundColorForBananaRepublic(t, applied),
  border: `1px solid ${t.color.g4}`,
  color: getButtonTextColorForBananaRepublic(t, applied),
  // outline: `1px solid ${t.color.b2}`,
  outline: `1px solid #000000`,
  fontWeight: 'bold',
  // @ts-ignore
  border: 0,
});
